module.exports = __webpack_public_path__ + "static/media/UI-Typing.811ff718.wav";